import { createSafeContext } from 'ui';

import { RowContextValue } from './rowContext.types';

export const [RowContextMenuProvider, useRowContextMenu] = createSafeContext<RowContextValue>(
  'Row Context component was not found in tree'
);
